import L from 'leaflet';

export const activityPoint = (type = 'point') => {
  return new L.Icon({
    iconUrl:
      type === 'point'
        ? '/images/markers/empty-positive.png'
        : '/images/markers/empty-selected.png',
    shadowUrl: '/images/markers/shadow.png',
    iconSize: [20, 36],
    shadowSize: [30, 15],
    iconAnchor: [10, 36],
    shadowAnchor: [0, 15],
    popupAnchor: [8, 30],
  });
};